var map = {
	"./1stCheck.svg": 3487,
	"./All_Services.svg": 60257,
	"./Arrow.svg": 44665,
	"./Ascending.svg": 94652,
	"./Authorization.svg": 21885,
	"./Avatar.svg": 12831,
	"./Business.svg": 62911,
	"./Calendar.svg": 68238,
	"./ChevronDown.svg": 32777,
	"./ChevronUp.svg": 34784,
	"./Cloud_Upload.svg": 23503,
	"./Condition.svg": 31929,
	"./Descending.svg": 65668,
	"./Error.svg": 34041,
	"./Failed.svg": 81010,
	"./Logo.svg": 46850,
	"./Message.svg": 37842,
	"./MoneyRequest.svg": 42673,
	"./Money_Transfer.svg": 48693,
	"./More.svg": 73080,
	"./Multi_Business.svg": 60441,
	"./Multi_User.svg": 19422,
	"./PaymentGateway.svg": 45138,
	"./Pending.svg": 77778,
	"./Personal.svg": 91199,
	"./Suspend.svg": 97172,
	"./Time.svg": 30714,
	"./Warning.svg": 31405,
	"./Yellow Diamond (2).svg": 84267,
	"./auth/IPG.svg": 60483,
	"./auth/Settlement.svg": 4918,
	"./bank-card.svg": 8769,
	"./bankInvoice.svg": 71185,
	"./banks/10.svg": 50536,
	"./banks/101.svg": 94674,
	"./banks/102.svg": 81764,
	"./banks/103.svg": 52900,
	"./banks/104.svg": 81111,
	"./banks/11.svg": 15672,
	"./banks/12.svg": 16050,
	"./banks/13.svg": 1506,
	"./banks/14.svg": 29637,
	"./banks/15.svg": 95180,
	"./banks/16.svg": 61655,
	"./banks/17.svg": 18279,
	"./banks/18.svg": 44249,
	"./banks/19.svg": 38983,
	"./banks/20.svg": 69724,
	"./banks/21.svg": 50061,
	"./banks/22.svg": 78653,
	"./banks/51.svg": 65198,
	"./banks/52.svg": 61482,
	"./banks/53.svg": 42017,
	"./banks/54.svg": 64094,
	"./banks/55.svg": 32697,
	"./banks/56.svg": 96270,
	"./banks/57.svg": 83080,
	"./banks/58.svg": 67946,
	"./banks/59.svg": 88676,
	"./banks/60.svg": 1677,
	"./banks/61.svg": 4834,
	"./banks/62.svg": 97077,
	"./banks/63.svg": 62480,
	"./banks/64.svg": 43811,
	"./banks/65.svg": 20211,
	"./banks/66.svg": 19453,
	"./banks/69.svg": 10639,
	"./banks/70.svg": 86521,
	"./banks/73.svg": 44807,
	"./banks/75.svg": 96019,
	"./banks/78.svg": 60140,
	"./banks/79.svg": 90213,
	"./banks/80.svg": 14313,
	"./banks/90.svg": 78855,
	"./banks/95.svg": 21295,
	"./banks/undefined.svg": 89644,
	"./border-bottom.svg": 44623,
	"./box-gray-past-time.svg": 23481,
	"./box-green-question.svg": 63677,
	"./box-grren-past-time.svg": 32674,
	"./bullet.svg": 87207,
	"./calendar-range-outline.svg": 2071,
	"./checkbox-marked-circle-outline.svg": 61931,
	"./chevron-left.svg": 73233,
	"./circles-back.svg": 40025,
	"./clock-outline.svg": 22532,
	"./close-circle-outline.svg": 88125,
	"./credit.svg": 39529,
	"./done.svg": 93944,
	"./download-icon.svg": 92428,
	"./download-outline.svg": 51076,
	"./error-warning.svg": 99323,
	"./file-uploader/delete.svg": 83268,
	"./file-uploader/pdf.svg": 94419,
	"./folder-plus-outline.svg": 39568,
	"./gingool.svg": 45702,
	"./github-circle.svg": 98997,
	"./google-plus.svg": 99775,
	"./guide-icon-second.svg": 34549,
	"./guide-icon.svg": 54795,
	"./hourglass-empty.svg": 12450,
	"./hourglass-ticket.svg": 60064,
	"./inProgress.svg": 11768,
	"./info.svg": 85533,
	"./info_red.svg": 61662,
	"./invoiceIcon.svg": 47257,
	"./ipg-soft-reject-pending.svg": 15416,
	"./ipg-soft-reject.svg": 78315,
	"./joker.svg": 44294,
	"./line.svg": 98158,
	"./logo-white.svg": 15700,
	"./logoType.svg": 52328,
	"./message-reply.svg": 67117,
	"./moneyHint.svg": 7386,
	"./newIcon/A2ACellings.svg": 85971,
	"./newIcon/Correction.svg": 6946,
	"./newIcon/Done.svg": 88566,
	"./newIcon/Done_Down.svg": 24663,
	"./newIcon/Failed.svg": 61811,
	"./newIcon/IPG.svg": 18378,
	"./newIcon/Ipg-warning.svg": 45137,
	"./newIcon/IpgPending.svg": 43718,
	"./newIcon/IpgPendingNew.svg": 22847,
	"./newIcon/IpgVip.svg": 88516,
	"./newIcon/P2P.svg": 76216,
	"./newIcon/PaymentForm.svg": 99637,
	"./newIcon/Payment_Form.svg": 40614,
	"./newIcon/Subscribe.svg": 19204,
	"./newIcon/Union.svg": 17145,
	"./newIcon/add-user.svg": 18235,
	"./newIcon/add_business.svg": 58297,
	"./newIcon/ascending_pack.svg": 59341,
	"./newIcon/autoCashIn.svg": 16298,
	"./newIcon/ayandehLogo.svg": 45266,
	"./newIcon/banksLogoCollection.svg": 77866,
	"./newIcon/cancel.svg": 82644,
	"./newIcon/cash-in-icon.svg": 42475,
	"./newIcon/cash-in-manual.svg": 77577,
	"./newIcon/cashInPending.svg": 37415,
	"./newIcon/check.svg": 28257,
	"./newIcon/contract.svg": 87826,
	"./newIcon/contractIcon.svg": 80263,
	"./newIcon/daily-report.svg": 74123,
	"./newIcon/error.svg": 44502,
	"./newIcon/error_close.svg": 19443,
	"./newIcon/failed-circle.svg": 63198,
	"./newIcon/file-excel-outline.svg": 8958,
	"./newIcon/grayLocation.svg": 2426,
	"./newIcon/homeTools.svg": 96365,
	"./newIcon/iBan.svg": 55070,
	"./newIcon/ibanShaparak.svg": 60782,
	"./newIcon/ibans.svg": 69623,
	"./newIcon/info.svg": 62292,
	"./newIcon/information.svg": 64826,
	"./newIcon/internetBank.svg": 60748,
	"./newIcon/ipg-document.svg": 9118,
	"./newIcon/ipg-square.svg": 22384,
	"./newIcon/ipgDialog.svg": 52946,
	"./newIcon/ipgDialogNew.svg": 4229,
	"./newIcon/kerdar.svg": 96372,
	"./newIcon/key.svg": 789,
	"./newIcon/location.svg": 38898,
	"./newIcon/lock.svg": 59355,
	"./newIcon/miandoPending.svg": 4124,
	"./newIcon/p2pPending.svg": 41164,
	"./newIcon/payment_form_card.svg": 49870,
	"./newIcon/pbvFirstTime.svg": 3502,
	"./newIcon/pbvPending.svg": 62471,
	"./newIcon/pending-square-yellow.svg": 98015,
	"./newIcon/pendingBusiness.svg": 79282,
	"./newIcon/receipt.svg": 91821,
	"./newIcon/refundPending.svg": 61015,
	"./newIcon/request_money.svg": 993,
	"./newIcon/sandbox.svg": 25399,
	"./newIcon/settlement_batch_gray.svg": 74086,
	"./newIcon/shaparak.svg": 6640,
	"./newIcon/simple-check.svg": 54289,
	"./newIcon/subscribePending.svg": 31326,
	"./newIcon/taxID.svg": 1417,
	"./newIcon/tools/A2A.svg": 33747,
	"./newIcon/tools/MPG.svg": 36244,
	"./newIcon/tools/PBV.svg": 98827,
	"./newIcon/tools/accountant.svg": 61608,
	"./newIcon/tools/cash-in.svg": 23523,
	"./newIcon/tools/customer.svg": 17428,
	"./newIcon/tools/fee.svg": 16860,
	"./newIcon/tools/ipg.svg": 42663,
	"./newIcon/tools/kerdar.svg": 3124,
	"./newIcon/tools/log.svg": 26064,
	"./newIcon/tools/miando.svg": 6280,
	"./newIcon/tools/moghayerat.svg": 55281,
	"./newIcon/tools/p2p.svg": 52350,
	"./newIcon/tools/p2p_new.svg": 77435,
	"./newIcon/tools/pos.svg": 35701,
	"./newIcon/tools/reconciliation.svg": 10062,
	"./newIcon/tools/refund.svg": 32062,
	"./newIcon/tools/request-money.svg": 1345,
	"./newIcon/tools/requestMoney.svg": 21166,
	"./newIcon/tools/settlement.svg": 62161,
	"./newIcon/tools/settlement_batch.svg": 10004,
	"./newIcon/tools/subscription.svg": 14175,
	"./newIcon/tools/success.svg": 51153,
	"./newIcon/tools/tools.svg": 21474,
	"./newIcon/tools/total.svg": 88679,
	"./newIcon/transaction-turnover.svg": 11821,
	"./newIcon/wallet.svg": 95498,
	"./newIcon/warning-circle.svg": 66310,
	"./newIcon/warning.svg": 88709,
	"./newIcon/whatsnew-white.svg": 81343,
	"./newIcon/whatsnew.svg": 75091,
	"./newIcon/whatsnewToolbar.svg": 13008,
	"./newIcon/yellowInfo.svg": 83196,
	"./newIcon/yellowWarning.svg": 7534,
	"./newIcon/yellow_box_ipg_vip_icon.svg": 29581,
	"./newIcon/yellow_info.svg": 12836,
	"./not-complete.svg": 44830,
	"./onboarding/Authorization.svg": 93866,
	"./onboarding/EmailConfirm.svg": 26466,
	"./onboarding/iBan.svg": 92218,
	"./onboarding/id-card.svg": 75379,
	"./onboarding/idCard.svg": 69087,
	"./overdraft.svg": 50034,
	"./plus.svg": 84355,
	"./refund-message.svg": 64754,
	"./reloadIcon.svg": 95703,
	"./round-nonField-warning.svg": 71681,
	"./secondCheck.svg": 68248,
	"./slider1.svg": 37157,
	"./slider3.svg": 41527,
	"./slider4.svg": 39939,
	"./slider5.svg": 42693,
	"./soft-pending.svg": 43995,
	"./soft-warning.svg": 89691,
	"./textMessage.svg": 9337,
	"./tools/A2A-introduce.svg": 90440,
	"./tools/accountant-introduce.svg": 73833,
	"./tools/api.svg": 86136,
	"./tools/apired.svg": 92062,
	"./tools/customer-introduce.svg": 63027,
	"./tools/customer.svg": 61378,
	"./tools/customerred.svg": 72610,
	"./tools/gray-A2A.svg": 22849,
	"./tools/gray-accountant.svg": 68747,
	"./tools/gray-customer.svg": 70722,
	"./tools/gray-kerdar.svg": 12474,
	"./tools/gray-requestMoney.svg": 38125,
	"./tools/gray-settlement_batch.svg": 23462,
	"./tools/gray-subscription.svg": 49854,
	"./tools/inquiry-introduce.svg": 88078,
	"./tools/invoice.svg": 31181,
	"./tools/invoiceAndCustomer.svg": 77483,
	"./tools/invoicered.svg": 3256,
	"./tools/ipg-introduce.svg": 41572,
	"./tools/ipg.svg": 32607,
	"./tools/ipgGreen.svg": 86810,
	"./tools/ipgred.svg": 62165,
	"./tools/kerdar-introduce.svg": 16192,
	"./tools/log.svg": 6809,
	"./tools/log_Big.svg": 52695,
	"./tools/logred.svg": 62694,
	"./tools/miando.svg": 70767,
	"./tools/p2p.svg": 86100,
	"./tools/p2pGreen.svg": 2541,
	"./tools/p2pYellow.svg": 52152,
	"./tools/p2pred.svg": 55312,
	"./tools/requestMoney-introduce.svg": 59208,
	"./tools/requestMoney.svg": 89950,
	"./tools/requestMoneyGreen.svg": 61023,
	"./tools/requestMoneyred.svg": 12117,
	"./tools/settlement_batch-introduce.svg": 38780,
	"./tools/settlement_batch.svg": 90610,
	"./tools/subscription-introduce.svg": 95434,
	"./tools/subscription.svg": 95376,
	"./tools/subscriptionGreen.svg": 10881,
	"./tools/subscriptionred.svg": 42512,
	"./trustedDevice/DESKTOP.svg": 21251,
	"./trustedDevice/MOBILE.svg": 48686,
	"./trustedDevice/TABLET.svg": 65075,
	"./trustedDevice/UNKNOWN.svg": 47705,
	"./ul.svg": 24314,
	"./undefined.svg": 11122,
	"./vandar-avatar.svg": 999,
	"./vandar-logo-sign.svg": 35099,
	"./vandarLogo.svg": 77996,
	"./wage.svg": 93010,
	"./wageHint.svg": 14285,
	"./walletAmountError.svg": 12780,
	"./warning-onboarding.svg": 37513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58278;